import {
	httpDeleteRequest,
	httpGetRequest,
	httpPostRequest,
	httpPutRequest,
} from "clients/phronesisClient"
import {
	MedalliaHistory,
	TermsVersion,
	UserField,
	Users,
	UserRequired,
	Organizations,
	Roles,
	Vendors,
	Categories,
	Brands,
	OrganizationRequired,
	Organization,
} from "./interfaces"
import { MEDALLIA_LAST_UPDATE } from "constants/medallia"
import { OrganizationFields } from "./components/Forms/Users/utils"

export const USERS_ENDPOINT = "/administration/users"
export const ORGANIZATIONS_ENDPOINT = "/administration/organizations"
export const VENDORS_ENDPOINT = "/filters/vendors"
export const ROLES_ENDPOINT = "/administration/roles"
export const PLANS_ENDPOINT = "/administration/plans"
export const BRANDS_ENDPOINT = "/filters/brands"
export const CATEGORIES_ENDPOINT = "/filters/categories"

export const getUsers = async (cancelToken: any): Promise<Users> => {
	return await httpGetRequest<Users>(
		USERS_ENDPOINT,
		undefined,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getOrganizations = async (
	cancelToken: any
): Promise<Organizations> => {
	return await httpGetRequest<Organizations>(
		ORGANIZATIONS_ENDPOINT,
		undefined,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getRoles = async (cancelToken: any): Promise<Roles> => {
	return await httpGetRequest<Roles>(
		ROLES_ENDPOINT,
		undefined,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getVendors = async (cancelToken: any): Promise<Vendors> => {
	return await httpGetRequest<Vendors>(
		VENDORS_ENDPOINT,
		undefined,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getPlans = async (cancelToken: any): Promise<Vendors> => {
	return await httpGetRequest<Vendors>(
		PLANS_ENDPOINT,
		undefined,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getBrands = async (
	cancelToken: any,
	params: any
): Promise<Brands> => {
	return await httpGetRequest<Brands>(
		BRANDS_ENDPOINT,
		params,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const getCategories = async (
	cancelToken: any,
	params: any
): Promise<Categories> => {
	return await httpGetRequest<Categories>(
		CATEGORIES_ENDPOINT,
		params,
		undefined,
		cancelToken,
		undefined,
		0
	)
}

export const postOrganization = async (
	organization: OrganizationFields | OrganizationRequired
): Promise<boolean> => {
	try {
		await httpPostRequest(ORGANIZATIONS_ENDPOINT, organization)
		return true
	} catch (e) {
		return false
	}
}

export const postUsers = async (
	user: UserField | UserRequired
): Promise<boolean> => {
	try {
		await httpPostRequest(USERS_ENDPOINT, user)
		return true
	} catch (e) {
		return false
	}
}

export const putUser = async (user: UserField): Promise<boolean> => {
	try {
		await httpPutRequest(`${USERS_ENDPOINT}/${user.email}`, user)
		return true
	} catch (e) {
		return false
	}
}

export const deleteUser = async (user: UserField): Promise<any> => {
	return await httpDeleteRequest(`${USERS_ENDPOINT}/${user.email}`)
}

export const deleteOrganization = async (
	organization: Organization
): Promise<any> => {
	return await httpDeleteRequest(`${ORGANIZATIONS_ENDPOINT}/${organization.id}`)
}

export const putUserTerms = async (
	userEmail: string,
	termsVersion: TermsVersion
): Promise<boolean> => {
	try {
		await httpPutRequest(`${USERS_ENDPOINT}/${userEmail}/terms`, termsVersion)
		return true
	} catch (e) {
		return false
	}
}

export const putUserMedallia = async (
	userEmail: string,
	medallia: MedalliaHistory
): Promise<boolean> => {
	try {
		await httpPutRequest(`${USERS_ENDPOINT}/${userEmail}/medallia`, medallia)
		localStorage.setItem(MEDALLIA_LAST_UPDATE, medallia.medallia_last_update)
		return true
	} catch (e) {
		return false
	}
}
